import { render, staticRenderFns } from "./RefundFlowList.vue?vue&type=template&id=7b406bf9&scoped=true&"
import script from "./RefundFlowList.vue?vue&type=script&lang=js&"
export * from "./RefundFlowList.vue?vue&type=script&lang=js&"
import style0 from "./RefundFlowList.vue?vue&type=style&index=0&id=7b406bf9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b406bf9",
  null
  
)

export default component.exports